export default __webpack_public_path__ + "static/media/revitrobot0407to15072022.a90e0a4d.jpeg";